import "core-js/modules/es.number.constructor.js";
export default {
  name: 'design-dialog',
  props: {
    // 弹窗宽度
    width: {
      type: [String, Number],
      default: 960
    },
    // 标题
    title: {
      type: String
    },
    // 是否显示
    visible: {
      type: Boolean,
      default: false
    },
    // 是否垂直居中显示
    centered: {
      type: Boolean,
      default: true
    },
    // 定位层级
    zIndex: {
      type: Number,
      default: 1000
    },
    // loading
    confirmLoading: {
      type: Boolean,
      default: false
    },
    // 确认文案
    okText: {
      type: String,
      default: '确定'
    },
    // 取消文案
    cancelText: {
      type: String,
      default: '取消'
    },
    wrapClassName: {
      type: String
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    // 确认
    handleOk: function handleOk() {
      this.$emit('isOk');
    },
    // 取消
    handleCancel: function handleCancel() {
      this.$emit('isCancel');
    }
  }
};